import { useSelector } from "react-redux";

import { Grid } from "@material-ui/core";

import { ActionTimeGroup } from "../../../../components/actionTimeTimeGroup";

import { CarbonReductionTotal } from "./CarbonReductionTotal";
import { CarbonReductionOverTime } from "./CarbonReductionOverTime";
import { PortfolioBenchmark } from "./PortfolioBenchmark";

export const SaveThePlanetTab = () => {
  const { period, startDate, endDate } = useSelector((state) => state.selectedPeriods);

  return (
    <div>
      <ActionTimeGroup />

      <Grid container spacing={4} alignItems="stretch">
        <Grid item xs={12} sm={4} style={{ display: "flex" }}>
          <CarbonReductionTotal period={period} startDate={startDate} endDate={endDate} />
        </Grid>
        <Grid item xs={12} sm={4} style={{ display: "flex" }}>
          <CarbonReductionOverTime period={period} startDate={startDate} endDate={endDate} />
        </Grid>
        <Grid item xs={12} sm={4} style={{ display: "flex" }}>
          <PortfolioBenchmark period={period} startDate={startDate} endDate={endDate} />
        </Grid>
      </Grid>
    </div>
  );
};
